import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from '../../../../../../i18n/use-translation';
import { Button } from '../../../../../atoms/button';
import { SmallPreloader } from '../../../../../atoms/preloaders/smal_preloader';
import { Size } from '../../../../../enums/size';
import { Input } from '../../../../../molecules/Input';
import { useViewModel } from './hook/use-view-model';
import { DEFAULT_VALUES } from './res/default-values';
import { getValidator } from './res/get-validator';
import { CompleteFormProps } from './type/props';

export const CompleteForm = (props: CompleteFormProps) => {
  const { t } = useTranslation();
  const { formSubmitHandler, isLoading } = useViewModel({
    phone: props.phone!,
  });

  return (
    // @ts-ignore
    <Formik initialValues={{ ...DEFAULT_VALUES }} validationSchema={getValidator(t)} onSubmit={formSubmitHandler}>
      <Form>
        <Input name="code" mask="999999" label={t('code')} hint={t('register.sms.description')} />
        {isLoading ? <SmallPreloader /> : <Button type="submit" text={t('registration.complete')} size={Size.BIG} />}
      </Form>
    </Formik>
  );
};
